import { Center } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useTitle } from 'react-use'
import { Container } from '../../common/components/Container'
import { TextLink } from '../../common/components/TextLink'
import { Title } from '../components/Title'

const PasswordResetRequestComplete: FC = () => {
  const [t] = useTranslation()
  useTitle(t('HU-IAAS パスワードリセット'))

  return (
    <Container innerWidth={'800px'}>
      <Title text={t('パスワードリセット')} />
      <div className={'mt24'}>
        {t('入力されたアドレス宛にメールを送信しました。')}
        <br />
        {t('メール本文に記載されているURLにアクセスしてパスワード登録を行ってください。')}
      </div>
      <div className={'mt24'}>
        <Center className={'mt8'}>
          <TextLink text={t('トップページへ戻る')} to={'/login'} />
        </Center>
      </div>
    </Container>
  )
}

export default PasswordResetRequestComplete
